import React, { useEffect, useState } from 'react';
import { Select, Tabs, Tab } from '@veneer/core';
import { useTranslation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

const BonusTable = (props) => {
  const { t, i18n } = useTranslation();
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [countrySelected, setcountrySelected] = useState('');
  const subregions = JSON.parse(localStorage.getItem("currentUser")).idSubRegion;

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
    });
    if (validate==false){
        const { history } = props;
        history.push({
            pathname: '/' 
        });
    }
    //end validate
    console.log(subregions);
    if (subregions.split(',').findIndex(x => x.trim() == '31') > -1) {
      
      setcountrySelected('Bolivia')
    }
    if (subregions.split(',').findIndex(x => x.trim() == '32') > -1) {
      setcountrySelected('Argentina')
    }
    if (subregions.split(',').findIndex(x => x.trim() == '3') > -1) {
      setcountrySelected('Mexico')
    }
    if (subregions.split(',').findIndex(x => x.trim() == '2') > -1) {
      setcountrySelected('Brazil')
    }
  }, [subregions]);

  const selectTab = (event) => (index) => {
    setactiveTabIndex(index);
  };

  const RenderTabs = () => {
    const mainTab = {
      // <Tab key="main" title="Bonus Table" onClick={selectTab(0)}>
      id: 0,
      label: <Trans i18nKey="bonus table" />,
      content: (
        <div class="bonus-card-container">
          <div className="bonus-card">
            <h5><Trans i18nKey="bonustable.series2" /></h5>
            <br />
            <p><strong><Trans i18nKey="bonustable.model" /></strong> 3000, 3050, 3500, 3550, 3600, 5000, 5500, 5600, 5900, 5r, r4050, w3250, ws4000, ws4050, ws4500, ws4600</p>
            <br />
            <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
              <thead>
                <tr>
                  <th><Trans i18nKey="bonustable.table1" /></th>
                  <th><Trans i18nKey="bonustable.table2" /></th>
                  <th><Trans i18nKey="bonustable.table3" /></th>
                  <th><Trans i18nKey="bonustable.table4" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0</td>
                  <td>200,000</td>
                  <td>0%</td>
                  <td rowspan="2">20% upfront</td>
                </tr>
                <tr>
                  <td>200,001</td>
                  <td>---</td>
                  <td>5%</td>
                </tr>
              </tbody>
            </table>
          </div>
          {(subregions.split(',').findIndex(x => x.trim() == '2') > -1) ? (
            <div className="bonus-card">
              <h5><Trans i18nKey="bonustable.series3AB" /></h5>
              <br />
              <p><strong><Trans i18nKey="bonustable.model" /></strong> 7000, 7500, 7600, 7800, 7900, 7r, w7200, w7250, ws6000, ws6600, ws6800, 6r</p>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th><Trans i18nKey="bonustable.table1" /></th>
                    <th><Trans i18nKey="bonustable.table2" /></th>
                    <th><Trans i18nKey="bonustable.table3" /></th>
                    <th><Trans i18nKey="bonustable.table4" /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>400,000</td>
                    <td>0%</td>
                    <td rowspan="4">upfront</td>
                  </tr>
                  <tr>
                    <td>400,001</td>
                    <td>800,000</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>800,001</td>
                    <td>1,200,000</td>
                    <td>10%</td>
                  </tr>
                  <tr>
                    <td>1,200,001</td>
                    <td>2,400,000</td>
                    <td>15%</td>
                  </tr>
                  <tr>
                    <td>2,400,001</td>
                    <td>6,000,000</td>
                    <td>20%</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>6,000,001</td>
                    <td>---</td>
                    <td>30%</td>
                    <td>15%</td>
                  </tr>
                </tbody>
              </table>
            </div>

          ) : undefined}
          {(subregions.split(',').findIndex(x => x.trim() == '3') > -1) ? (
            <div className="bonus-card">
              <h5><Trans i18nKey="bonustable.series3AM" /></h5>
              <br />
              <p><strong><Trans i18nKey="bonustable.model" /></strong> 7000, 7500, 7600, 7800, 7900, 7r, w7200, w7250, ws6000, ws6600, ws6800, 6r</p>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th><Trans i18nKey="bonustable.table1" /></th>
                    <th><Trans i18nKey="bonustable.table2" /></th>
                    <th><Trans i18nKey="bonustable.table3" /></th>
                    <th><Trans i18nKey="bonustable.table4" /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>400,000</td>
                    <td>0%</td>
                    <td rowspan="3">upfront</td>
                  </tr>
                  <tr>
                    <td>400,001</td>
                    <td>800,000</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>800,001</td>
                    <td>1,200,000</td>
                    <td>10%</td>
                  </tr>
                  <tr>
                    <td>1,200,001</td>
                    <td>2,400,000</td>
                    <td>15%</td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>2,400,001</td>
                    <td>6,000,000</td>
                    <td>20%</td>
                    <td>10%</td>
                  </tr>
                  <tr>
                    <td>6,000,001</td>
                    <td>10,000,000</td>
                    <td>25%</td>
                    <td>15%</td>
                  </tr>
                  <tr>
                    <td>10,000,001</td>
                    <td>---</td>
                    <td>30%</td>
                    <td>20%</td>
                  </tr>
                </tbody>
              </table>
            </div>

          ) : undefined}
          {(subregions.split(',').findIndex(x => x.trim() == '31' || x == '32') > -1) ? (
            <>
              <div className="bonus-card">
                <h5><Trans i18nKey="bonustable.series3MCA" /></h5>
                <br />
                <p><strong><Trans i18nKey="bonustable.model" /></strong> ws6000, ws6600, ws6800, 6r, w7200, w7250</p>
                <br />
                <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                  <thead>
                    <tr>
                      <th><Trans i18nKey="bonustable.table1" /></th>
                      <th><Trans i18nKey="bonustable.table2" /></th>
                      <th><Trans i18nKey="bonustable.table3" /></th>
                      <th><Trans i18nKey="bonustable.table4" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>0</td>
                      <td>400,000</td>
                      <td>0%</td>
                      <td rowspan="3">upfront</td>
                    </tr>
                    <tr>
                      <td>400,001</td>
                      <td>800,000</td>
                      <td>5%</td>
                    </tr>
                    <tr>
                      <td>800,001</td>
                      <td>1,200,000</td>
                      <td>10%</td>
                    </tr>
                    <tr>
                      <td>1,200,001</td>
                      <td>2,400,000</td>
                      <td>15%</td>
                      <td>5%</td>
                    </tr>
                    <tr>
                      <td>2,400,001</td>
                      <td>6,000,000</td>
                      <td>20%</td>
                      <td>10%</td>
                    </tr>
                    <tr>
                      <td>6,000,001</td>
                      <td>10,000,000</td>
                      <td>25%</td>
                      <td>15%</td>
                    </tr>
                    <tr>
                      <td>10,000,001</td>
                      <td>---</td>
                      <td>30%</td>
                      <td>20%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bonus-card">
                <h5><Trans i18nKey="bonustable.series3MCA" /></h5>
                <br />
                <p><strong><Trans i18nKey="bonustable.model" /></strong> 7000, 7500, 7600, 7800, 7900, 7r:</p>
                <br />
                <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                  <thead>
                    <tr>
                      <th><Trans i18nKey="bonustable.table1" /></th>
                      <th><Trans i18nKey="bonustable.table2" /></th>
                      <th><Trans i18nKey="bonustable.table3" /></th>
                      <th><Trans i18nKey="bonustable.table4" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>0</td>
                      <td>400,000</td>
                      <td>0%</td>

                      <td>0%</td>
                    </tr>

                    <tr>
                      <td>400,001</td>
                      <td>800,000</td>
                      <td>5%</td>

                      <td>5%</td>
                    </tr>

                    <tr>
                      <td>800,001</td>
                      <td>1,200,000</td>
                      <td>10%</td>

                      <td>10%</td>
                    </tr>

                    <tr>
                      <td>1,200,001</td>
                      <td>2,400,000</td>
                      <td>15%</td>

                      <td>15%</td>
                    </tr>

                    <tr>
                      <td>2,400,001</td>
                      <td>6,000,000</td>
                      <td>20%</td>

                      <td>20%</td>
                    </tr>

                    <tr>
                      <td>6,000,001</td>
                      <td>10,000,000</td>
                      <td>25%</td>

                      <td>25%</td>
                    </tr>

                    <tr>
                      <td>10,000,001</td>
                      <td>---</td>
                      <td>30%</td>

                      <td>30%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ) : undefined}
        </div>
      ),
      // </Tab>
    };

    const brazilTable = () => {
      return (
        <>
          <h5>MSRP per Click for end USER in US$ – BRAZIL (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to End user</h5>
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0364</td>
                    <td align="center">$0.0345</td>
                    <td align="center">$0.0306</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0364</td>
                    <td align="center">$0.0345</td>
                    <td align="center">$0.0306</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0498</td>
                    <td align="center">$0.0474</td>
                    <td align="center">$0.0448</td>
                    <td align="center">$0.0398</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo  20000/25k  -  Click price HP to End user</h5>
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0788</td>
                    <td align="center">$0.0747</td>
                    <td align="center">$0.0709</td>
                    <td align="center">$0.0631</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0788</td>
                    <td align="center">$0.0747</td>
                    <td align="center">$0.0709</td>
                    <td align="center">$0.0631</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0394</td>
                    <td align="center">$0.0394</td>
                    <td align="center">$0.0394</td>
                    <td align="center">$0.0394</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to End user</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0425</td>
                    <td align="center">$0.0404</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0363</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0425</td>
                    <td align="center">$0.0404</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0363</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0229</td>
                    <td align="center">$0.0229</td>
                    <td align="center">$0.0229</td>
                    <td align="center">$0.0229</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const argentinaTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const boliviaTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const caribeTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const centroAmericaTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const chileTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const colombiaTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const ecuadorTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const mexicoTable = () => {
      return (
        <>
          <h5>MSRP per Click for end USER in US$ – MEXICO (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to End user</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0362</td>
                    <td align="center">$0.0344</td>
                    <td align="center">$0.0326</td>
                    <td align="center">$0.0290</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0362</td>
                    <td align="center">$0.0344</td>
                    <td align="center">$0.0326</td>
                    <td align="center">$0.0290</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0474</td>
                    <td align="center">$0.0448</td>
                    <td align="center">$0.0323</td>
                    <td align="center">$0.0376</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo  20000/25k  -  Click price HP to End user</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0715</td>
                    <td align="center">$0.0679</td>
                    <td align="center">$0.0644</td>
                    <td align="center">$0.0494</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0715</td>
                    <td align="center">$0.0679</td>
                    <td align="center">$0.0644</td>
                    <td align="center">$0.0494</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0274</td>
                    <td align="center">$0.0274</td>
                    <td align="center">$0.0274</td>
                    <td align="center">$0.0274</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to End user</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0377</td>
                    <td align="center">$0.0359</td>
                    <td align="center">$0.0340</td>
                    <td align="center">$0.0320</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0377</td>
                    <td align="center">$0.0359</td>
                    <td align="center">$0.0340</td>
                    <td align="center">$0.0320</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0207</td>
                    <td align="center">$0.0207</td>
                    <td align="center">$0.0207</td>
                    <td align="center">$0.0207</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const peruTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    const uruguayTable = () => {
      return (
        <>
          <h5>Price per Click for end-user in USD – FOB Israel (**)</h5>
          <div className="bonus-card-container">
            <div className="bonus-card">
              <h5>HP Indigo 1x000/15k - Click price HP to Partner</h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0296</td>
                    <td align="center">$0.0285</td>
                    <td align="center">$0.0273</td>
                    <td align="center">$0.0246</td>
                  </tr>
                  <tr>
                    <td align="center">One Shot</td>
                    <td align="center">$0.0384</td>
                    <td align="center">$0.0370</td>
                    <td align="center">$0.0354</td>
                    <td align="center">$0.0319</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 20000/25k -  Click price HP to Partner  </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B1 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,000,000</td>
                    <td align="center">1,000,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0584</td>
                    <td align="center">$0.0562</td>
                    <td align="center">$0.0539</td>
                    <td align="center">$0.0424</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                    <td align="center">$0.0234</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bonus-card">
              <h5>HP Indigo 30000/35k -  Click price HP to Partner </h5>
              <br />
              <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
                <thead>
                  <tr>
                    <th align="center"></th>
                    <th align="center">TIER 1</th>
                    <th align="center">TIER 2</th>
                    <th align="center">TIER 3</th>
                    <th align="center">TIER 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">B2 Clicks</td>
                    <td align="center">0 - 500,000</td>
                    <td align="center">500,001 - 1,200,000</td>
                    <td align="center">1,200,001 - 1,500,000</td>
                    <td align="center">&gt; 1,500,000</td>
                  </tr>
                  <tr>
                    <td align="center">Black</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">Other Colors (*)</td>
                    <td align="center">$0.0360</td>
                    <td align="center">$0.0347</td>
                    <td align="center">$0.0333</td>
                    <td align="center">$0.0317</td>
                  </tr>
                  <tr>
                    <td align="center">White (*)</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                    <td align="center">$0.0195</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    };

    useEffect(() => {
      //validate location
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      let validate=false;
      currentUser.urls.forEach(ur=>{
          if (ur==window.location.pathname){
              validate=true;
          }
      });
      if (validate==false){
          const { history } = props;
          history.push({
              pathname: '/' 
          });
      }
      //end validate
      countryTable();
    }, [countrySelected]);

    const countryTable = () => {
      switch (countrySelected) {
        case 'Argentina':
          return argentinaTable();
        case 'Brazil':
          return brazilTable();
        case 'Bolivia':
          return boliviaTable();
        case 'Caribe':
          return caribeTable();
        case 'Centroamerica':
          return centroAmericaTable();
        case 'Chile':
          return chileTable();
        case 'Colombia':
          return colombiaTable();
        case 'Ecuador':
          return ecuadorTable();
        case 'Mexico':
          return mexicoTable();
        case 'Peru':
          return peruTable();
        case 'Uruguay':
          return uruguayTable();
        case 'Venezuela':
          return venezuelaTable();
        default:
          return defaultTable();
      }
    };

    const defaultTable = () => {
      return <div></div>;
    };

    const countrySelect = () => {
      const handleStatusChange = (name) => (event) => {
        setcountrySelected(event.value);
      };

      const getSelectOptions = () => {
        let options = [];
        if (subregions.split(',').findIndex(x => x.trim() == '31') > -1) {
          options.push({ value: 'Bolivia' });
          options.push({ value: 'Colombia' });
          options.push({ value: 'Ecuador' });
          options.push({ value: 'Peru' });
          options.push({ value: 'Uruguay' });
          options.push({ value: 'Venezuela' });
          options.push({ value: 'Caribe' });
          options.push({ value: 'Centroamerica' });
        }
        if (subregions.split(',').findIndex(x => x.trim() == '32') > -1) {
          options.push({ value: 'Argentina' });
          options.push({ value: 'Chile' });
        }
        if (subregions.split(',').findIndex(x => x.trim() == '3') > -1) {
          options.push({ value: 'Mexico' });
        }
        if (subregions.split(',').findIndex(x => x.trim() == '2') > -1) {
          options.push({ value: 'Brazil' });
        }

        options.sort();

        //setcountrySelected((options.findIndex(x => x.value == 'Brazil') > -1) ? 'Brazil' : options[0].value);

        return options;
      }

      return (
        <div
          style={{
            width: '170px',
            marginBottom: '16px',
          }}
        >
          <Select
            name="type"
            onChange={handleStatusChange()}
            options={getSelectOptions()}
            value={[countrySelected]}
            clearIcon={false}
          ></Select>
        </div>
      );
    };

    const venezuelaTable = () => {
      return (
        <div className="bonus-card-container">
          <div className="bonus-card">
            <h5>HP Indigo 10000/12000 - Click price HP to End user</h5>
            <br />
            <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
              <thead>
                <tr>
                  <td align="center"></td>
                  <td align="center">TIER 1</td>
                  <td align="center">TIER 2</td>
                  <td align="center">TIER 3</td>
                  <td align="center">TIER 4</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">B2 Clicks</td>
                  <td align="center">0 - 500,000</td>
                  <td align="center">500,001 - 1,200,000</td>
                  <td align="center">1,200,001 - 1,500,000</td>
                  <td align="center">&gt; 1,500,000</td>
                </tr>
                <tr>
                  <td align="center">Black</td>
                  <td align="center">$0.0336</td>
                  <td align="center">$0.0323</td>
                  <td align="center">$0.0310</td>
                  <td align="center">$0.0279</td>
                </tr>
                <tr>
                  <td align="center">Other Colors (*)</td>
                  <td align="center">$0.0336</td>
                  <td align="center">$0.0323</td>
                  <td align="center">$0.0310</td>
                  <td align="center">$0.0279</td>
                </tr>
                <tr>
                  <td align="center">One Shot</td>
                  <td align="center">$0.0436</td>
                  <td align="center">$0.0420</td>
                  <td align="center">$0.0402</td>
                  <td align="center">$0.0363</td>
                </tr>
                <tr>
                  <td align="center">EPM</td>
                  <td align="center">$0.0336</td>
                  <td align="center">$0.0323</td>
                  <td align="center">$0.0310</td>
                  <td align="center">$0.0279</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bonus-card">
            <h5>HP Indigo 20000 - Click price HP to End user</h5>
            <br />
            <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
              <thead>
                <tr>
                  <td align="center"></td>
                  <td align="center">TIER 1</td>
                  <td align="center">TIER 2</td>
                  <td align="center">TIER 3</td>
                  <td align="center">TIER 4</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">B1 Clicks</td>
                  <td align="center">0 - 500,000</td>
                  <td align="center">500,001 - 1,000,000</td>
                  <td align="center">1,000,001 - 1,500,000</td>
                  <td align="center">&gt; 1,500,000</td>
                </tr>
                <tr>
                  <td align="center">Black</td>
                  <td align="center">$0.0663</td>
                  <td align="center">$0.0638</td>
                  <td align="center">$0.0612</td>
                  <td align="center">$0.0481</td>
                </tr>
                <tr>
                  <td align="center">Other Colors (*)</td>
                  <td align="center">$0.0663</td>
                  <td align="center">$0.0638</td>
                  <td align="center">$0.0612</td>
                  <td align="center">$0.0481</td>
                </tr>
                <tr>
                  <td align="center">White (*)</td>
                  <td align="center">$0.0265</td>
                  <td align="center">$0.0265</td>
                  <td align="center">$0.0265</td>
                  <td align="center">$0.0265</td>
                </tr>
                <tr>
                  <td align="center">EPM</td>
                  <td align="center">$0.0663</td>
                  <td align="center">$0.0638</td>
                  <td align="center">$0.0612</td>
                  <td align="center">$0.0481</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bonus-card">
            <h5>HP Indigo 30000 - Click price HP to End user</h5>
            <br />
            <table className="bonus-table table table-striped table-hover table-bordered table-sm table-fit">
              <thead>
                <tr>
                  <td align="center"></td>
                  <td align="center">TIER 1</td>
                  <td align="center">TIER 2</td>
                  <td align="center">TIER 3</td>
                  <td align="center">TIER 4</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">B2 Clicks</td>
                  <td align="center">0 - 500,000</td>
                  <td align="center">500,001 - 1,200,000</td>
                  <td align="center">1,200,001 - 1,500,000</td>
                  <td align="center">&gt; 1,500,000</td>
                </tr>
                <tr>
                  <td align="center">Black</td>
                  <td align="center">$0.0409</td>
                  <td align="center">$0.0394</td>
                  <td align="center">$0.0378</td>
                  <td align="center">$0.0360</td>
                </tr>
                <tr>
                  <td align="center">Other Colors (*)</td>
                  <td align="center">$0.0409</td>
                  <td align="center">$0.0394</td>
                  <td align="center">$0.0378</td>
                  <td align="center">$0.0360</td>
                </tr>
                <tr>
                  <td align="center">White (*)</td>
                  <td align="center">$0.0221</td>
                  <td align="center">$0.0221</td>
                  <td align="center">$0.0221</td>
                  <td align="center">$0.0221</td>
                </tr>
                <tr>
                  <td align="center">EPM</td>
                  <td align="center">$0.0409</td>
                  <td align="center">$0.0394</td>
                  <td align="center">$0.0378</td>
                  <td align="center">$0.0360</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    };

    const secondTab = {
      // <Tab key="secondTab" title="Click Series 4" onClick={selectTab(1)}>
      id: 2,
      label: 'Click Series 4',
      content: (
        <div>
          <br />
          {countrySelect()}

          {countryTable()}

          <div style={{ marginTop: '16px', marginLeft: '16px' }}>
            <p>
              <strong><Trans i18nKey="bonustable.notes1" />:</strong>
            </p>
            <p>
              <strong>
                <Trans i18nKey="bonustable.notes2" />
              </strong>
            </p>
            <p>
              <strong><Trans i18nKey="bonustable.notes3" /></strong>
            </p>
            <p>
              <strong><Trans i18nKey="bonustable.notes4" /></strong>
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li>
                <Trans i18nKey="bonustable.notes5" />
              </li>
              <li>
                <Trans i18nKey="bonustable.notes6" />
              </li>
            </ul>
          </div>
        </div>
      ),
    };

    const list = [mainTab, secondTab];
    //const list = [mainTab];
    const tab = (
      <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        tabs={list}
      >
        {/* {list} */}
      </Tabs>
    );

    return tab;
  };

  return (
    <div>
      <br />
      <h4 style={{ marginBottom: '16px' }}><Trans i18nKey="supplies program" /></h4>
      <p>
        <Trans i18nKey="supplies program txt" />{' '}
      </p>
      <p>
        <Trans i18nKey="supplies program txt 2" />
      </p>
      <p> <Trans i18nKey="supplies program txt 3" /></p>

      <br />
      <RenderTabs />
      <br />
      <br />
    </div>
  );
};

export default withTranslation()(BonusTable);